import { Icon } from "@/components/common/Icon";

export type ChoiceIndicatorKind = "radio" | "checkbox";

/** 選択肢の左端に置く、単一選択のラジオ・複数選択のチェックボックス。 */
export function ChoiceIndicator({
	kind,
	checked,
}: {
	kind: ChoiceIndicatorKind;
	checked: boolean;
}) {
	const filled = kind === "checkbox" && checked;
	return (
		<span className="flex h-lh w-4.5 shrink-0 items-center justify-center">
			<span
				className={`flex h-4.5 w-4.5 items-center justify-center ${
					kind === "radio" ? "rounded-full" : "rounded-2"
				}`}
				style={{
					border: `1.5px solid ${
						checked ? (filled ? "var(--accent-solid)" : "var(--accent)") : "var(--fg-4)"
					}`,
					backgroundColor: filled ? "var(--accent-solid)" : undefined,
				}}
			>
				{checked &&
					(kind === "radio" ? (
						<span className="h-2 w-2 rounded-full bg-accent" />
					) : (
						<Icon name="check" size={12} stroke={2} color="var(--on-accent-solid)" />
					))}
			</span>
		</span>
	);
}
